<template>
  <div>
    <el-form
        ref="ruleFormPackage"
        :model="ruleFormPackage"
        :rules="rules"
    >
      <el-form-item
          label="Tên gói"
          prop="name"
          style="display: flex"
      >
        <el-input
            placeholder="Nhập tên gói..."
            type="text"
            v-model="ruleFormPackage.name"
            autocomplete="off"
            class="no-border"
        />
      </el-form-item>

      <el-form-item
          label="Mô tả"
          prop="description"
          style="display: flex"
      >
        <el-input
            placeholder="Nhập mô tả cho gói..."
            :rows="4" type="text"
            v-model="ruleFormPackage.description"
            autocomplete="off"
            class="no-border"
        />
      </el-form-item>

      <el-form-item>
        <div style="display: flex; justify-content: end">
          <el-button
              type="success"
              icon="el-icon-circle-check"
              @click="submitForm('ruleFormPackage')"
          >
            Lưu
          </el-button>
          <el-button
              type="danger"
              @click="resetForm"
              icon="el-icon-circle-close"
          >
            Đóng
          </el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import {OperationPackage} from "@/services/PackageService";

const props = {
  dataUpdate: {
    type: Object,
    required: true,
  }
}

export default {
  props: props,
  data() {
    return {
      ruleFormPackage: {
        id: this.dataUpdate.id,
        name: this.dataUpdate.namePackage,
        description: this.dataUpdate.descriptionPackage,
      },
      rules: {
        name: [
          {required: true, message: 'Không được để trống trường này!', trigger: 'blur'},
        ],
      }
    }
  },
  watch: {
    dataUpdate: {
      handler(newVal) {
        this.ruleFormPackage.id = newVal.id;
        this.ruleFormPackage.name = newVal.namePackage;
        this.ruleFormPackage.description = newVal.descriptionPackage;
      },
    },
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.fetchUpdatePackage();
        } else {
          return false;
        }
      });
    },

    resetForm() {
      this.$refs.ruleFormPackage.resetFields();
      this.dataUpdate = {};
      this.$emit('closeDialogUpdate');
    },

    handleUpdatePackages(data) {
      this.$store.dispatch("packageStore/updatePackages", data);
    },

    fetchUpdatePackage() {
      OperationPackage.updatePackage(this.ruleFormPackage)
          .then((res) => {
            console.log(res.data.data);
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "success",
            });
            this.handleUpdatePackages(res.data.data);
            this.resetForm();
          })
          .catch((err) => {
            console.log(err);
            return this.$message({
              showClose: true,
              message: `Lỗi hệ thống `,
              type: "danger",
            });
          })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-form-item__content {
  width: 100%;
}

/deep/ .no-border .el-input__inner {
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
  width: 100%;
}

/deep/ .el-form-item__label {
  width: 85px;
}
</style>